import { DEFAULT_CONSTANT, IKey } from "../../../constants";

export class ConstantService {
  static getConstant(key: keyof IKey) {
    return DEFAULT_CONSTANT[key];
  }
}
